import script from "./AddToCollectionAtom.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddToCollectionAtom.vue?vue&type=script&setup=true&lang=ts"

import "./AddToCollectionAtom.vue?vue&type=style&index=0&id=b4a2c988&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4a2c988"]])

export default __exports__